import PendingScreen from 'features/advance/screens/lightning/Pending/Pending';
import React from 'react';

const PendingPage = () => <PendingScreen />;

export default PendingPage;
